import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthenticationService, UtilsService,ChangePasswordComponent} from 'usermgmt';
import { SideMenuService } from '../sidemenu/sidemenu.service';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'ngx-mobile-app';
import { WebServiceService } from 'ngx-web-app';
import { Subject, takeUntil } from 'rxjs';
import { APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnDestroy{
  isSidebar: boolean = false;
  spinner: boolean = false;
  @Input() path?: any;
  @Output() onLogin = new EventEmitter<any>();
  @Output() sidebar = new EventEmitter<boolean>();
  @Input() toggle: boolean = false;
  loggedIn: boolean = true;
  showHeader: boolean = true;
  userInfo: any = {};
  logoConfig: any;
  config: any;
  constant = {};
  sidebarState: boolean = false;
  landingScreen: boolean = true;
  profileToggle: boolean = false;
  requriedActions: boolean = false;
  usemgmt: boolean = false;
  logoutState: boolean = false;
  applicationName!: string;
  applicationNameDisplay: boolean = false;
  isWebBuilder: boolean = false;
  isMobileBuilder: boolean = false;
  publishToggle = false;
  private destroy$ = new Subject<void>();
  appPermissions: any = APP_BUILDER_PERMISSIONS;
  permissionsActions: any = PERMISSIONS_ACTIONS;

  constructor(
    private router: Router,
    private authSrv: AuthenticationService,
    private utilSrv: UtilsService,
    private smService: SideMenuService,
    private mbSharedService: SharedService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public wbService: WebServiceService
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(async (val: any) => {
      this.landingScreen = window.location.href
        .split("/")
        .includes("landing-page");
      this.requriedActions = window.location.href
        .split("/")?.[5]
        ?.includes("required-actions");
      this.usemgmt = window.location.href.split("/").includes("um");
      this.isWebBuilder = window.location.href.includes("web");
      this.profileToggle = false;
      this.loggedIn = this.authSrv.isLoggedIn();
      this.userInfo = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo") as string)
        : null;

      if(window.location.href.split("/").includes("login-keycloak")){
        this.showHeader =  false;
      }else{
        this.showHeader = true;
      }
    });
  }

  ngOnInit(): void {
    this.logoutState = false;
    this.loggedIn = this.authSrv.isLoggedIn();
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.isWebBuilder = window.location.href.includes("web");
      this.isMobileBuilder = window.location.href.includes("mobile");
      if (
        (params?.["id"] && params?.["applicationType"]) ||
        (params?.["id"] && params?.["pageId"])
      ) {
      } else {
        this.applicationNameDisplay = false;
      }
    });

    this.mbSharedService.logoutUser$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (value) {
        this.utilSrv.logout();
      }
    });

    this.mbSharedService.currentApplicationName$.pipe(takeUntil(this.destroy$)).subscribe(
      (appName: string) => {
        if(appName){
          this.applicationNameDisplay = true
          this.applicationName = appName;
        }
      }
    );
  }

  async logout() {
    await this.utilSrv.logout();
    this.router.navigate(['','login-keycloak']);
  }

  sidebarAction() {
    this.profileToggle = false;
    this.toggle = !this.toggle;
    this.smService.toggle();
    this.sidebar.emit(this.toggle);
  }

  navigateToPage(route: any) {
    if (route == "home") {
      this.mbSharedService.clearBreadcrumb();
    }
    this.router.navigate([route], {});
  }
  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
    });
  }
  
  openPublish() {
    if (this.isWebBuilder) {
      this.wbService.setSelectedOption("Publish", this.publishToggle);
    } else if(this.isMobileBuilder) {
      const currentSelectedOption = this.mbSharedService.getSelectedOption();
      if(currentSelectedOption.label === "Publish"){
        this.mbSharedService.setSelectedOption("Publish", !currentSelectedOption.isActive);
      }else{
        this.mbSharedService.setSelectedOption("Publish", true);
      }
    }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
